import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-full',
  templateUrl: './blank-full.component.html',
  styleUrls: ['./blank-full.component.scss']
})
export class BlankFullComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
